import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("announcement-bar", {
  initSlider() {
    const carousel = this.container.querySelector(
      ".announcement-bar__carousel"
    );
    let loop =
    carousel.querySelectorAll(".announcement-bar__message").length > 1
      ? true
      : false;
    const autoplay_time = parseInt(carousel.dataset.autoplayTime);
    const autoplay_enable = carousel.dataset.autoplayEnable == 'true' ? {
      delay: autoplay_time,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
      waitForTransition: false
    } : false;
    if (!carousel) return;
    if (autoplay_enable) loop = false;
    const swiper = new Swiper(carousel, {
      loop: false,
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: autoplay_enable,
      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      },
    });
  },

 

  onLoad: function (e) {
    this.initSlider();
  },
});
